import React from "react";
import "./styleLoaderDot.css";

function LoaderDot() {
  return (
    <div className="loader_body " style={{ marginTop: "7px" }}>
      <div className="loader-outer">
        <div className="loader">
          <span className="dot dot-1  bg-danger"></span>
          <span className="dot dot-2 bg-danger"></span>
          <span className="dot dot-3 bg-danger"></span>
        </div>
      </div>
    </div>
  );
}

export default LoaderDot;
